<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc2"><a href="#/v1/1cover">Wuthering Heights</a></p>
<p class="toc2"><span href="#/v2/cover" title="Link target outside of Sample">Pride and Prejudice</span></p>
<p class="toc2"><span href="#/v3/cover" title="Link target outside of Sample">Far from the Madding Crowd</span></p>
<p class="toc2"><span href="#/v4/1cover" title="Link target outside of Sample">Jane Eyre</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maintoc.vue?9c905120